// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* CartLayout.css */

.layout-div {
  width: 97%;
  margin: 1rem auto;
  flex: 0.5 1;
  /* background: rgb(255, 255, 255); */
  border-radius: 10px;
  /* box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px; */
  padding: 1rem;
  /* transition: box-shadow 0.3s ease; */
}

.heading {
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 20px;
  text-align: center;
}

.input-field-cart_layout {
  display: flex;
  align-items: center;
  width: 100%;
  height: 100px;
  margin-bottom: 0.2rem;
  border-radius: 10px;
  /* background: rgb(247, 243, 243); */
  transition: box-shadow 1.s ease;
  /* box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 5px; */

}

.input-field-cart_layout input {
  margin-right: 20px; 
  margin-left: 20px;/* Add space between input fields */

}

.input-field-cart_layout:last-child {
  margin-bottom: 0; /* Remove margin from the last input field */
}

.input-cart_layout:hover {
  box-shadow: rgba(0, 0, 0, 0.35) 0px 10px 20px;
}

.input-cart_layout {
  width: 50%;
  padding: 1.1rem;
  border: none;
  border-radius: 10px;
  outline: none;
  /* background: rgb(241, 237, 237) transparent; */
}

.input-field-cart_layout input[type="number"]::-webkit-inner-spin-button,
.input-field-cart_layout input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
   margin: 0;
}

.main-div {
  display: flex;
  flex-direction: row;
}

.left-div {
  width: 75%;
  text-align: center;
  margin: 1rem auto;
  background: rgb(247, 243, 243);
  border-radius: 10px;
  /* box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px; */
  padding: 1rem;
  transition: box-shadow 0.3s ease;
}

.right-div {
  width: auto;
  text-align: center;
  margin: 1rem auto;
  background: rgb(247, 243, 243);
  transition: box-shadow 0.3s ease;
  border-radius: 10px;
  /* box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px; */
  padding: 1rem;
 
}
.rupee-image{
  height: 30px;
  width: 20px;
}
table {
  width: 100%;
  border-collapse: collapse;
  margin: 0 auto;
  text-align: center; /* Center the table horizontally */
}

th, td {
  padding: 10px; /* Adjust the padding as needed */
  border: 1px solid #ccc;
  text-align: center; /* Center the text in th and td elements */
}

.title-div {
  font-weight: bold;
}

.amount-div {
  text-align: right;
}

.remove-div {
  text-align: center;
  cursor: pointer;
}
.left-div-image {
  width: 50px;
  height: 50px;
  object-fit: cover;
}


.cart-checkbox-div {
  display: flex;
  align-items: center;
  margin-top: 20px;
}

.cart-cancellation-policy-link {
  color: #007bff;
  text-decoration: underline;
}
/* CartLayout.css */


@media (max-width: 768px) {
  .layout-div {
    width:340px;
  }

  .main-div {
    flex-direction: column;
  }

  .left-div{
    width: 300px;
    margin-top: 20px;
    height:330px;
    /* background-color: rgb(193, 193, 199); */
  }
  .right-div {
    width: 300px;
    margin-top: 20px;
    height: -moz-fit-content;
    height: fit-content;
  }

  .left-div-image {
    width:30px; /* Adjust as needed */
    height: auto;
  }

  .input-cart_layout {
    width: 260px;
  }
  .input-field-cart_layout{
    display: grid;
    padding: auto;
    height: 250px;
    width: 337px;
    align-items: center;
  }
}
`, "",{"version":3,"sources":["webpack://./src/FrontEnd/Cart/CartLayOut.css"],"names":[],"mappings":"AAAA,mBAAmB;;AAEnB;EACE,UAAU;EACV,iBAAiB;EACjB,WAAS;EACT,oCAAoC;EACpC,mBAAmB;EACnB,kDAAkD;EAClD,aAAa;EACb,sCAAsC;AACxC;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,aAAa;EACb,qBAAqB;EACrB,mBAAmB;EACnB,oCAAoC;EACpC,+BAA+B;EAC/B,iDAAiD;;AAEnD;;AAEA;EACE,kBAAkB;EAClB,iBAAiB,CAAC,mCAAmC;;AAEvD;;AAEA;EACE,gBAAgB,EAAE,4CAA4C;AAChE;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,UAAU;EACV,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,gDAAgD;AAClD;;AAEA;;EAEE,wBAAwB;GACvB,SAAS;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,iBAAiB;EACjB,8BAA8B;EAC9B,mBAAmB;EACnB,kDAAkD;EAClD,aAAa;EACb,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,8BAA8B;EAC9B,gCAAgC;EAChC,mBAAmB;EACnB,kDAAkD;EAClD,aAAa;;AAEf;AACA;EACE,YAAY;EACZ,WAAW;AACb;AACA;EACE,WAAW;EACX,yBAAyB;EACzB,cAAc;EACd,kBAAkB,EAAE,kCAAkC;AACxD;;AAEA;EACE,aAAa,EAAE,iCAAiC;EAChD,sBAAsB;EACtB,kBAAkB,EAAE,0CAA0C;AAChE;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;;AAGA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;AACA,mBAAmB;;;AAGnB;EACE;IACE,WAAW;EACb;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,YAAY;IACZ,gBAAgB;IAChB,YAAY;IACZ,0CAA0C;EAC5C;EACA;IACE,YAAY;IACZ,gBAAgB;IAChB,wBAAmB;IAAnB,mBAAmB;EACrB;;EAEA;IACE,UAAU,EAAE,qBAAqB;IACjC,YAAY;EACd;;EAEA;IACE,YAAY;EACd;EACA;IACE,aAAa;IACb,aAAa;IACb,aAAa;IACb,YAAY;IACZ,mBAAmB;EACrB;AACF","sourcesContent":["/* CartLayout.css */\n\n.layout-div {\n  width: 97%;\n  margin: 1rem auto;\n  flex: 0.5;\n  /* background: rgb(255, 255, 255); */\n  border-radius: 10px;\n  /* box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px; */\n  padding: 1rem;\n  /* transition: box-shadow 0.3s ease; */\n}\n\n.heading {\n  font-size: 24px;\n  font-weight: bold;\n  margin-bottom: 20px;\n  text-align: center;\n}\n\n.input-field-cart_layout {\n  display: flex;\n  align-items: center;\n  width: 100%;\n  height: 100px;\n  margin-bottom: 0.2rem;\n  border-radius: 10px;\n  /* background: rgb(247, 243, 243); */\n  transition: box-shadow 1.s ease;\n  /* box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 5px; */\n\n}\n\n.input-field-cart_layout input {\n  margin-right: 20px; \n  margin-left: 20px;/* Add space between input fields */\n\n}\n\n.input-field-cart_layout:last-child {\n  margin-bottom: 0; /* Remove margin from the last input field */\n}\n\n.input-cart_layout:hover {\n  box-shadow: rgba(0, 0, 0, 0.35) 0px 10px 20px;\n}\n\n.input-cart_layout {\n  width: 50%;\n  padding: 1.1rem;\n  border: none;\n  border-radius: 10px;\n  outline: none;\n  /* background: rgb(241, 237, 237) transparent; */\n}\n\n.input-field-cart_layout input[type=\"number\"]::-webkit-inner-spin-button,\n.input-field-cart_layout input[type=\"number\"]::-webkit-outer-spin-button {\n  -webkit-appearance: none;\n   margin: 0;\n}\n\n.main-div {\n  display: flex;\n  flex-direction: row;\n}\n\n.left-div {\n  width: 75%;\n  text-align: center;\n  margin: 1rem auto;\n  background: rgb(247, 243, 243);\n  border-radius: 10px;\n  /* box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px; */\n  padding: 1rem;\n  transition: box-shadow 0.3s ease;\n}\n\n.right-div {\n  width: auto;\n  text-align: center;\n  margin: 1rem auto;\n  background: rgb(247, 243, 243);\n  transition: box-shadow 0.3s ease;\n  border-radius: 10px;\n  /* box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px; */\n  padding: 1rem;\n \n}\n.rupee-image{\n  height: 30px;\n  width: 20px;\n}\ntable {\n  width: 100%;\n  border-collapse: collapse;\n  margin: 0 auto;\n  text-align: center; /* Center the table horizontally */\n}\n\nth, td {\n  padding: 10px; /* Adjust the padding as needed */\n  border: 1px solid #ccc;\n  text-align: center; /* Center the text in th and td elements */\n}\n\n.title-div {\n  font-weight: bold;\n}\n\n.amount-div {\n  text-align: right;\n}\n\n.remove-div {\n  text-align: center;\n  cursor: pointer;\n}\n.left-div-image {\n  width: 50px;\n  height: 50px;\n  object-fit: cover;\n}\n\n\n.cart-checkbox-div {\n  display: flex;\n  align-items: center;\n  margin-top: 20px;\n}\n\n.cart-cancellation-policy-link {\n  color: #007bff;\n  text-decoration: underline;\n}\n/* CartLayout.css */\n\n\n@media (max-width: 768px) {\n  .layout-div {\n    width:340px;\n  }\n\n  .main-div {\n    flex-direction: column;\n  }\n\n  .left-div{\n    width: 300px;\n    margin-top: 20px;\n    height:330px;\n    /* background-color: rgb(193, 193, 199); */\n  }\n  .right-div {\n    width: 300px;\n    margin-top: 20px;\n    height: fit-content;\n  }\n\n  .left-div-image {\n    width:30px; /* Adjust as needed */\n    height: auto;\n  }\n\n  .input-cart_layout {\n    width: 260px;\n  }\n  .input-field-cart_layout{\n    display: grid;\n    padding: auto;\n    height: 250px;\n    width: 337px;\n    align-items: center;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
